import { AreaFooterLink } from '@/store/slices/stagesSlice/interfaces'
import styles from './AreaPageFooter.module.scss'

export const AreaPageFooter = ({ links }: { links?: AreaFooterLink[] | null }) => {
  const sortedLinks = links ? [...links].sort((a, b) => a.order - b.order) : []

  return (
    <footer className={styles.footer}>
      <div className={styles.footer__content}>
        <ul className={styles.footer__links}>
          {sortedLinks.map(link => (
            <li key={link.order}>
              <a
                className={styles.footer__linksItem}
                href={link.url}
                target="_blank"
                rel="noopener"
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
        <img
          className={styles.footer__image}
          src="/images/payment-methods.svg"
          alt="Способы оплаты"
        />
      </div>
    </footer>
  )
}
